import React from 'react';

// assets
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';

// constant

// ==============================|| ADVANCED MENU ITEMS ||============================== //

const advanced = {
	id: 'advanced',
	title: 'Advanced',
	type: 'group',
	children: [
		{
			id: 'bank-details',
			title: 'Bank Details',
			type: 'item',
			url: '/bank-details',
			icon: SavingsOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default advanced;
